import { observable, action } from "mobx";
//import { WeaLocaleProvider } from "ecCom";
// import { message} from 'antd';
// import API from '../../apis';
//const getLabel = WeaLocaleProvider.getLabel;
/**
 * 批量打印
 */
export default class BatchPrintStore {
    @observable modeid ="";
    @observable formid ="";
    @observable billid ="";
    @observable search ="";
    @observable customId = "";
    @observable printMap:any;
    //该批量打印store暂时不用。
    @action
    batchPrint = () => {
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/stores/batchPrint/index.tsx